import React, { useState, useRef } from 'react';
import './NotesSection.css';

const TagInput = ({ tags, onChange, placeholder = 'Type and press comma or Enter to add tags' }) => {
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    const addTag = (tagText) => {
        const trimmed = tagText.trim();
        if (trimmed && !tags.includes(trimmed)) {
            onChange([...tags, trimmed]);
        }
    };

    const removeTag = (indexToRemove) => {
        onChange(tags.filter((_, index) => index !== indexToRemove));
    };

    const handleKeyDown = (e) => {
        if (e.key === ',' || e.key === 'Enter') {
            e.preventDefault();
            if (inputValue.trim()) {
                addTag(inputValue);
                setInputValue('');
            }
        } else if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
            removeTag(tags.length - 1);
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        // Check if user typed a comma
        if (value.includes(',')) {
            const parts = value.split(',');
            parts.forEach((part, index) => {
                if (index < parts.length - 1) {
                    addTag(part);
                } else {
                    setInputValue(part);
                }
            });
        } else {
            setInputValue(value);
        }
    };

    const handleBlur = () => {
        if (inputValue.trim()) {
            addTag(inputValue);
            setInputValue('');
        }
    };

    const handleContainerClick = () => {
        inputRef.current?.focus();
    };

    return (
        <div className="tag-input-container" onClick={handleContainerClick}>
            <div className="tag-input-tags">
                {tags.map((tag, index) => (
                    <span key={index} className="tag-input-chip">
                        {tag}
                        <button
                            type="button"
                            className="tag-remove-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                removeTag(index);
                            }}
                            aria-label={`Remove tag ${tag}`}
                        >
                            &times;
                        </button>
                    </span>
                ))}
                <input
                    ref={inputRef}
                    type="text"
                    value={inputValue}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    placeholder={tags.length === 0 ? placeholder : ''}
                    className="tag-input-field"
                />
            </div>
        </div>
    );
};

export default TagInput;
